import { Faq } from "@/components/General/Faq/faq";

type Props = {
    json: string;
};

export const FaqDefault = ({ json }: Props) => {
    return (
        <Faq json={json}>
            <Faq.Categories>
                <Faq.Categories.Button />
            </Faq.Categories>
            <Faq.Accordion>
                <Faq.Accordion.Item>
                    <Faq.Accordion.Item.Question />
                    <Faq.Accordion.Item.Answer />
                </Faq.Accordion.Item>
            </Faq.Accordion>
        </Faq>
    );
};
